var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import FormattedDuration, { TIMER_FORMAT } from 'react-intl-formatted-duration';
import styled from 'styled-components';
import Button from '../../../../core/components/Button';
import Image from '../../../../core/components/Uploaders/Image';
import { ButtonContainer, ImageContainer } from '../../../../core/components/Uploaders/Image/styles';
import { VideoContainer } from '../../../../core/components/Uploaders/Video/styles';
import useFile from '../../../../core/hooks/useFile';
import { Play, Remove } from '../../../../icons';
export const RemoveButton = styled(Button).attrs({
    variant: 'secondary',
    children: React.createElement(Remove, null),
}) `
  position: absolute;
  top: 0.5em;
  right: 0.5em;
`;
export const PlayIcon = styled(Play) `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const Duration = styled.div `
  position: absolute;
  left: 0.5rem;
  bottom: 0.5rem;
  padding: 1px 0.25rem;
  border-radius: 0.25rem;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;

  && {
    ${({ theme }) => theme.typography.caption}
  }
`;
export const Thumbnail = styled(({ className, duration, fileId, onRemove, overlayElements, showPlayIcon }) => {
    return fileId ? (React.createElement(Image, { "data-qa-anchor": "post-gallery-content-thumbnail", className: className, fileId: fileId, mediaFit: "cover", overlayElements: React.createElement(React.Fragment, null,
            overlayElements,
            showPlayIcon && React.createElement(PlayIcon, { "data-qa-anchor": "post-gallery-content-play-button" }),
            duration && (React.createElement(Duration, null,
                React.createElement(FormattedDuration, { seconds: duration, format: TIMER_FORMAT })))), onRemove: onRemove })) : (React.createElement(ImageContainer, { "data-qa-anchor": "post-gallery-content-thumbnail", className: className },
        React.createElement(ButtonContainer, null,
            overlayElements,
            showPlayIcon && React.createElement(PlayIcon, { "data-qa-anchor": "post-gallery-content-play-button" }),
            duration && (React.createElement(Duration, null,
                React.createElement(FormattedDuration, { seconds: duration, format: TIMER_FORMAT }))),
            !!onRemove && (React.createElement(RemoveButton, { onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onRemove();
                } })))));
}) `
  background: #ebecef;
`;
export const VideoThumbnail = styled((_a) => {
    var _b, _c, _d;
    var { fileId, videoFileId } = _a, props = __rest(_a, ["fileId", "videoFileId"]);
    const videoFile = useFile(videoFileId);
    const duration = typeof ((_d = (_c = (_b = videoFile === null || videoFile === void 0 ? void 0 : videoFile.attributes) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.video) === null || _d === void 0 ? void 0 : _d.duration) === 'number'
        ? videoFile.attributes.metadata.video.duration
        : undefined;
    return React.createElement(Thumbnail, Object.assign({}, props, { duration: duration, fileId: fileId }));
}) ``;
const VideoPlayerMockInternal = styled.div `
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  transform: translateY(-50%);
  padding-bottom: 56%;
  background: #000;
`;
export const VideoPlayerMock = styled((_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement("div", Object.assign({}, props),
        React.createElement(VideoPlayerMockInternal, null, children)));
}) `
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 825px;
  margin-right: auto;
  margin-left: auto;
`;
export const Message = styled.div `
  && {
    position: absolute;
    top: 50%;
    right: 1em;
    left: 1em;
    text-align: center;
    transform: translateY(-50%);
    color: #fff;
  }
`;
export const VideoMessage = styled(({ children, className, onRemove }) => (React.createElement(VideoContainer, { className: className },
    React.createElement(Message, null, children),
    React.createElement(ButtonContainer, null, !!onRemove && (React.createElement(RemoveButton, { onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            onRemove();
        } })))))) ``;
//# sourceMappingURL=styles.js.map